export default "__VITE_ASSET__BDbOUsgP__"